import { Controller } from "stimulus";

export default class ModalsController extends Controller {
  hide(): void {
    this.element?.classList.remove("show");
  }

  show(): void {
    this.element?.classList.add("show");
  }

  destroy(): void {
    this.element.remove();
  }
}
